import { produce } from 'immer'
import { State } from '../typings'

export type SetSavingAction = {
  type: 'setSaving'
  payload: boolean
}

export const setSaving = produce<State, [boolean]>((draft, payload) => {
  draft.saving = payload
})
